import { Fragment, FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { getProductType } from '@/redux/draft/getters/getProductType';
import { PanelInfo } from '@/components/common/panel/panel';

export const ProductTypeAttributes: FunctionComponent = () => {
  const { attributes } = useSelector(getProductType);
  if (attributes === null || !attributes.length) {
    return null;
  }

  return (
    <Fragment>
      {attributes.map(({ id, description }) => (
        <PanelInfo key={id}>{description}</PanelInfo>
      ))}
    </Fragment>
  );
};
